import styled from 'styled-components'

export const StyledFileName = styled.span`
    font-family: "Arial", sans-serif;
    font-size: 13px;
    color: grey;
    cursor: pointer;
    &:hover { color: black }
`;
